import cn from 'classnames'

import Skeleton from '../../../skeleton'

import styles from './styles.module.scss'

const Loading = ({ blocksCount = 2, skeletonsCount = 2 }: { blocksCount?: number; skeletonsCount?: number }) => {
  return (
    <div className={cn(styles.loading, 'arp-options_loading')}>
      {Array.from({ length: blocksCount }).map((_, index) => (
        <div key={index} className={styles.loading__block}>
          {Array.from({ length: skeletonsCount }).map((_, index) => (
            <Skeleton key={index} className={styles.loading__skeleton} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default Loading
